<template>
<div class="click-thru hideme">
    <div class="clickthru-top">{{clickThru.superHeader}}</div>
	<div class="clickthru-middle" v-on:click="nextCategory">{{clickThru.mainText}}</div>
    <div class="clickthru-bottom"></div>
</div>
</template>

<script>
	export default {
		name: 'click-thru',
		props: {
			clickThru: {
				required: true,
				type: Object
			}
		},
		methods: {
			nextCategory: function() {
				console.log('nextCategory start')
				this.$emit('clickThru');
			}
		}
	}
</script>


// WEBPACK FOOTER //
// ClickThru.vue?29b142ea